<template>
  <ScreenSplitter>
    <DxItem v-model:collapsed="drawerCollapseStates.left"
            :collapsible="true"
            :size="230"
            :min-size="230"
            :max-size="430"
    >
      <SearchToolDrawer/>
    </DxItem>

    <DxItem>
      <SearchPageContent/>
    </DxItem>

    <DxItem v-model:collapsed="drawerCollapseStates.right"
            :collapsible="true"
            :size="230"
            :min-size="230"
            :max-size="430"
    >
      <BasketActionDrawer/>
    </DxItem>
  </ScreenSplitter>
</template>

<script setup>
  import ScreenSplitter from "@/components/base-components/drawer/ScreenSplitter.vue";
  import SearchToolDrawer from "@/components/search-page/search-tool-drawer/SearchToolDrawer.vue";
  import BasketActionDrawer from "@/components/search-page/basket-action-drawer/BasketActionDrawer.vue";
  import SearchPageContent from "@/components/search-page/SearchPageContent.vue";
  import { DxItem } from 'devextreme-vue/splitter';
  import { storeToRefs } from "pinia";
  import { useHeaderStore } from "@/stores/headerStore.js";

  const headerStore = useHeaderStore()
  const { drawerCollapseStates } = storeToRefs(headerStore)
</script>

<style scoped lang="scss">

</style>
